import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5); // Countdown timer

  useEffect(() => {
    // Start the countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    // Redirect to login after 5 seconds
    const redirectTimer = setTimeout(() => {
      navigate("/login", { replace: true }); // ✅ Ensure proper navigation
    }, 5000);

    // Cleanup function to prevent memory leaks
    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, [navigate]);

  const handleBack = () => {
    navigate(-1); // Go back to the previous page
  };

  const handleHome = () => {
    navigate("/", { replace: true }); // ✅ Properly navigate to login
  };

  useEffect(() => {
    // ✅ Immediately redirect to home/login
    navigate("/", { replace: true });
  }, [navigate]);


  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-5xl font-extrabold text-blue-600 mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-700 mb-4">
        Page Not Found
      </h2>
      <p className="text-base text-gray-500 mb-4">
        Oops! The page you’re looking for doesn’t exist.
      </p>
      <p className="text-sm text-gray-400 mb-6">
        Redirecting to Login in{" "}
        <span className="font-bold text-blue-500">{countdown}</span> seconds...
      </p>
      <div className="flex space-x-4">
        {/* Back Button */}
        <button
          onClick={handleBack}
          className="px-6 py-2 bg-blue-500 text-white font-medium rounded-lg hover:bg-blue-600 transition"
        >
          Go Back
        </button>
        {/* Home/Login Button */}
        <button
          onClick={handleHome}
          className="px-6 py-2 bg-green-500 text-white font-medium rounded-lg hover:bg-green-600 transition"
        >
          Go Home/Login
        </button>
      </div>
    </div>
  );
};

export default NotFound;
